<template>
  <div>
    <v-row justify="end">
      <v-col class="px-0 d-flex" :class="'justify-' + justifyVal">
        <v-pagination
          v-model="page"
          :class="'d-flex justify-' + justifyVal"
          style="width: fit-content"
          :length="length"
          :total-visible="totalVisible"
        ></v-pagination>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  data() {
    return {
      page: 1,
    };
  },
  props: {
    justifyVal: {
      default: "end",
      type: String,
    },
    length: {
      default: 0,
      type: Number,
      required: true,
    },
    totalVisible: {
      default: 9,
      type: Number,
    },
  },
  watch: {
    page() {
      this.$emit("onPageSelect", this.page);
    },
    length() {
      this.page = 1;
    },
  },
};
</script>
<style scoped>
>>> .theme--light.v-pagination .v-pagination__item {
  background: none;
  box-shadow: none;
}
>>> .theme--light.v-pagination .v-pagination__navigation {
  background: none;
  box-shadow: none;
}
</style>
